const ectoplasm = (level) => {
  const handle = 'ectoplasm';
  const types = ['amorphous', 'undead', 'jelly'];
  const bags = [];
  const AI_PRIORITIES = ['support', 'dps_ranged', 'dps_close', 'interference', 'tank'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'lightning' },
    { value: 'void_spike' },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'ectoplasm_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          blurred_form: {
            handle: 'blurred_form',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          void_spike: {
            handle: 'void_spike',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          lightning: {
            handle: 'lightning',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          send_mana: {
            handle: 'send_mana',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(4 + bound_level * 0.6 + Math.random() * 3),
      perception: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      mana: Math.round(7 + bound_level * 1.0 + Math.random() * 3),
      toughness: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.3 + Math.random() * 3),
      willpower: Math.round(6 + bound_level * 0.8 + Math.random() * 3),
      dexterity: Math.round(4 + bound_level * 0.6 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 325,
    drops_gold: false,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = ectoplasm;
